import { formatDateWithLocalTZ } from '@ticomix/common';
import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

import { IAuthUserInfo } from './i-iauth-user-info';
import { throwException, blobToText } from './api-utilities';



export class AuthUserInfo implements IAuthUserInfo {
    Email?: string | null;
    UserName?: string | null;
    FirstName?: string | null;
    LastName?: string | null;
    PhoneNumber?: string | null;
    Roles!: string[];
    TwoFactorEnabled!: boolean;
    LastLogin?: Date | null;
    IsBellEmployee!: boolean;
    CustomerID?: number | null;
    DefaultLeaseWell?: string | null;
    DefaultAFENumber?: string | null;
    DefaultPONumber?: string | null;
    DefaultSellToContact?: string | null;
    DefaultSupervisorRequisitioner?: string | null;
    DefaultJobNumber?: string | null;
    DefaultCostCenterCFWBS?: string | null;
    DefaultMajorCode?: string | null;
    DefaultMinorCode?: string | null;
    DefaultGLCodeBillCat?: string | null;
    DefaultPropertyNumber?: string | null;

    constructor(data?: IAuthUserInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.Roles = [];
            this.TwoFactorEnabled = false;
            this.IsBellEmployee = false;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.Email = _data["Email"] !== undefined ? _data["Email"] : <any>null;
            this.UserName = _data["UserName"] !== undefined ? _data["UserName"] : <any>null;
            this.FirstName = _data["FirstName"] !== undefined ? _data["FirstName"] : <any>null;
            this.LastName = _data["LastName"] !== undefined ? _data["LastName"] : <any>null;
            this.PhoneNumber = _data["PhoneNumber"] !== undefined ? _data["PhoneNumber"] : <any>null;
            if (Array.isArray(_data["Roles"])) {
                this.Roles = [] as any;
                for (let item of _data["Roles"])
                    this.Roles!.push(item);
            }
            else {
                this.Roles = <any>null;
            }
            this.TwoFactorEnabled = _data["TwoFactorEnabled"] !== undefined ? _data["TwoFactorEnabled"] : false;
            this.LastLogin = _data["LastLogin"] ? new Date(_data["LastLogin"].toString()) : <any>null;
            this.IsBellEmployee = _data["IsBellEmployee"] !== undefined ? _data["IsBellEmployee"] : false;
            this.CustomerID = _data["CustomerID"] !== undefined ? _data["CustomerID"] : <any>null;
            this.DefaultLeaseWell = _data["DefaultLeaseWell"] !== undefined ? _data["DefaultLeaseWell"] : <any>null;
            this.DefaultAFENumber = _data["DefaultAFENumber"] !== undefined ? _data["DefaultAFENumber"] : <any>null;
            this.DefaultPONumber = _data["DefaultPONumber"] !== undefined ? _data["DefaultPONumber"] : <any>null;
            this.DefaultSellToContact = _data["DefaultSellToContact"] !== undefined ? _data["DefaultSellToContact"] : <any>null;
            this.DefaultSupervisorRequisitioner = _data["DefaultSupervisorRequisitioner"] !== undefined ? _data["DefaultSupervisorRequisitioner"] : <any>null;
            this.DefaultJobNumber = _data["DefaultJobNumber"] !== undefined ? _data["DefaultJobNumber"] : <any>null;
            this.DefaultCostCenterCFWBS = _data["DefaultCostCenterCFWBS"] !== undefined ? _data["DefaultCostCenterCFWBS"] : <any>null;
            this.DefaultMajorCode = _data["DefaultMajorCode"] !== undefined ? _data["DefaultMajorCode"] : <any>null;
            this.DefaultMinorCode = _data["DefaultMinorCode"] !== undefined ? _data["DefaultMinorCode"] : <any>null;
            this.DefaultGLCodeBillCat = _data["DefaultGLCodeBillCat"] !== undefined ? _data["DefaultGLCodeBillCat"] : <any>null;
            this.DefaultPropertyNumber = _data["DefaultPropertyNumber"] !== undefined ? _data["DefaultPropertyNumber"] : <any>null;
        }
    }

    static fromJS(data: any): AuthUserInfo {
        data = typeof data === 'object' ? data : {};
        let result = new AuthUserInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Email"] = this.Email !== undefined ? this.Email : <any>null;
        data["UserName"] = this.UserName !== undefined ? this.UserName : <any>null;
        data["FirstName"] = this.FirstName !== undefined ? this.FirstName : <any>null;
        data["LastName"] = this.LastName !== undefined ? this.LastName : <any>null;
        data["PhoneNumber"] = this.PhoneNumber !== undefined ? this.PhoneNumber : <any>null;
        if (Array.isArray(this.Roles)) {
            data["Roles"] = [];
            for (let item of this.Roles)
                data["Roles"].push(item);
        }
        data["TwoFactorEnabled"] = this.TwoFactorEnabled !== undefined ? this.TwoFactorEnabled : <any>null;
        data["LastLogin"] = this.LastLogin ? formatDateWithLocalTZ(this.LastLogin) : <any>null;
        data["IsBellEmployee"] = this.IsBellEmployee !== undefined ? this.IsBellEmployee : <any>null;
        data["CustomerID"] = this.CustomerID !== undefined ? this.CustomerID : <any>null;
        data["DefaultLeaseWell"] = this.DefaultLeaseWell !== undefined ? this.DefaultLeaseWell : <any>null;
        data["DefaultAFENumber"] = this.DefaultAFENumber !== undefined ? this.DefaultAFENumber : <any>null;
        data["DefaultPONumber"] = this.DefaultPONumber !== undefined ? this.DefaultPONumber : <any>null;
        data["DefaultSellToContact"] = this.DefaultSellToContact !== undefined ? this.DefaultSellToContact : <any>null;
        data["DefaultSupervisorRequisitioner"] = this.DefaultSupervisorRequisitioner !== undefined ? this.DefaultSupervisorRequisitioner : <any>null;
        data["DefaultJobNumber"] = this.DefaultJobNumber !== undefined ? this.DefaultJobNumber : <any>null;
        data["DefaultCostCenterCFWBS"] = this.DefaultCostCenterCFWBS !== undefined ? this.DefaultCostCenterCFWBS : <any>null;
        data["DefaultMajorCode"] = this.DefaultMajorCode !== undefined ? this.DefaultMajorCode : <any>null;
        data["DefaultMinorCode"] = this.DefaultMinorCode !== undefined ? this.DefaultMinorCode : <any>null;
        data["DefaultGLCodeBillCat"] = this.DefaultGLCodeBillCat !== undefined ? this.DefaultGLCodeBillCat : <any>null;
        data["DefaultPropertyNumber"] = this.DefaultPropertyNumber !== undefined ? this.DefaultPropertyNumber : <any>null;
        return data;
    }

}